var _filter, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHammer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "inset-shadow"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "offset-blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "offset-blur",
    result: "inverse"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "black",
    floodOpacity: 0.95,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color",
    in2: "inverse",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "over",
    in: "shadow",
    in2: "SourceGraphic"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    filter: "url(#inset-shadow)",
    d: "M12.055 3.81668C11.9866 3.62107 11.9807 3.40903 12.038 3.20988C12.0953 3.01074 12.2131 2.83432 12.375 2.70502L12.7317 2.44668C13.9811 1.62069 15.3998 1.08534 16.8834 0.880018C19.57 0.525018 22.9917 1.25835 26.32 5.06669H28.4284C28.6935 5.06692 28.9477 5.17243 29.135 5.36002L31.7084 7.93502C31.8951 8.12245 32 8.37626 32 8.64085C32 8.90545 31.8951 9.15925 31.7084 9.34669L26.565 14.505C26.4721 14.5982 26.3617 14.6722 26.2402 14.7227C26.1186 14.7732 25.9883 14.7991 25.8567 14.7991C25.7251 14.7991 25.5948 14.7732 25.4732 14.7227C25.3517 14.6722 25.2413 14.5982 25.1484 14.505L22.5784 11.9234C22.3912 11.7364 22.2857 11.4829 22.285 11.2184V9.94002L5.51171 27.6867C5.42625 27.8025 5.3168 27.8985 5.19085 27.9681C5.06489 28.0377 4.92539 28.0793 4.78187 28.0901C4.63836 28.1008 4.49421 28.0805 4.35928 28.0304C4.22435 27.9804 4.10181 27.9018 4.00004 27.8L1.00004 24.8C0.818682 24.6184 0.714075 24.3741 0.70787 24.1175C0.701666 23.861 0.794338 23.6118 0.966711 23.4217L19.2217 6.16169C17.7284 5.25002 15.6784 4.48502 12.9984 4.48502C12.791 4.48535 12.5887 4.42121 12.4194 4.30147C12.25 4.18173 12.1222 4.01232 12.0534 3.81668H12.055Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.b8d6e1f27eb1f523b744fbb7cc0e79c6.svg";
export { ForwardRef as ReactComponent };